import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question: "What marital status should I select if I'm in the process of getting divorced?",
    answer:
      "In some states, certain rights or designations may change during or after a divorce. Because divorce laws vary by state and timing can matter, we can't tell you how to answer this question, but you can always come back to make updates online if your situation changes.",
  },
  {
    question:
      'If someone named in my documents moves or changes their name after becoming married, do I need to update the information?',
    answer:
      "Minor changes, such as a new address or last name, do not always require document updates, but it's a good idea to review your plan periodically to make sure it still clearly identifies the intended person. You can come back to update your estate plan online as needed.",
  },
];

const BasicInfoFAQ = () => <FAQBase questions={questions} />;

export default BasicInfoFAQ;
